module.exports = __webpack_public_path__ + "static/media/APCO International Logo.1b8e3811.jpg";